import {
  containerFluid,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  hexToRgb,
  blackColor,
} from "assets/jss/emjayTheme.js";

const storeHourStyles = () => ({
  storeHourMainContainer: {
    paddingTop: 35,
    display:'flex',
    flexDirection: 'column',
    gap: '2rem',
    "& h4": {
      fontWeight: "bold",
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
  },
  sectionHeaderButtonContainer: {
    display: "flex",
    flex: 1,
    gap: '1rem',
    justifyContent: "flex-end",
  },
  dayContainer: {
    backgroundColor: "white",
    margin: "0.5rem 0",
    padding: "1rem",
  },
  dayContainerError: {
    backgroundColor: primaryColor[6],
  },
  error: {
    color: dangerColor[4],
    fontWeight: 'bold'
  },
  dayHeader: {
    display: "flex",
    flexDirection: "row",
  },
  dayName: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem'
  },
  openSwitchContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: "flex-end",
  },
  datePickersContainer: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  },
  switchBase: {
    color: primaryColor[0] + "!important",
  },
  switchIcon: {
    boxShadow: "0 1px 3px 1px rgba(" + hexToRgb(blackColor) + ", 0.4)",
    color: whiteColor + " !important",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    transform: "translateX(-9px) translateY(-5px)",
    width: 25,
  },
  switchIconChecked: {
    borderColor: primaryColor[0],
    transform: "translateX(0px)!important",
  },
  switchBar: {
    height: "15px",
    backgroundColor: "rgb(" + hexToRgb(grayColor[18]) + ")",
    borderRadius: "15px",
    opacity: "0.7!important",
  },
  switchChecked: {
    "& + $switchBar": {
      backgroundColor: "rgba(" + hexToRgb(primaryColor[0]) + ", 1) !important",
    },
    "& $switchIcon": {
      borderColor: primaryColor[0],
    },
  },
});

export default storeHourStyles;
